'use client'

import clsx from 'clsx'

import { DrawerTitle } from 'shared/ui/Drawer'

import ClearCartModal from '../../items/components/ClearCartModal'

import styles from './CartSummaryHeader.module.scss'

interface CartSummaryHeaderProps {
  productsCount: number
  hideRedirectButton?: boolean
  hideOnMobile?: boolean
  fullWidth?: boolean
  isInDrawer?: boolean
}

const CartSummaryHeader = ({
  hideRedirectButton,
  fullWidth,
  isInDrawer = false
}: CartSummaryHeaderProps) => {
  return (
    <div
      className={clsx(styles.wrapper, {
        [styles.wrapperHideRedirect]: hideRedirectButton,
        [styles.wrapperColumn]: !hideRedirectButton
      })}
    >
      <div className={styles.titleWrapper}>
        <div
          className={clsx(styles.cartDrawerTitleWrapper, {
            [styles.cartDrawerTitleWrapperFullWidth]: fullWidth
          })}
        >
          {isInDrawer ? (
            <DrawerTitle>Podgląd koszyka</DrawerTitle>
          ) : (
            <h2 className={styles.title}>Podgląd koszyka</h2>
          )}
          <ClearCartModal />
        </div>
      </div>
    </div>
  )
}

export default CartSummaryHeader
